import { Stack } from "@mui/material";
import { MprcFeedTypography } from "components/MprcFeedTypography";
import { FeedType, PublicationApprovalStatus } from "generated/CoreApi_v1";
import { CardChannelLink } from "views/knowledge/components/card/behaviors/common/CardChannelLink";
import { useCardContext } from "../../CardBuilder";
import { DefaultModerationClassification } from "./DefaultModerationClassification";

///
export const DefaultClassification = () => {
    const { pub, otherInfo } = useCardContext();

    if (pub.approvalStatus != PublicationApprovalStatus.Approved && otherInfo?.feedType != FeedType.ModeratePublications && otherInfo?.feedType != FeedType.ModerateReports) {
        return <DefaultModerationClassification />;
    }

    if ((pub.channel?.name == undefined || pub.channel?.name == null) && !pub.isPrivate)
        return false;

    return (
        <Stack direction="row" alignItems="center" justifyContent={otherInfo?.feedType == FeedType.Channel ? "flex-end" : "flex-start"} spacing={0.5}>
            {
                pub.channel?.name && otherInfo?.feedType != FeedType.Channel &&
                <MprcFeedTypography variant="classification" noWrap component="div">
                    <CardChannelLink />
                </MprcFeedTypography>
            }
        </Stack>
    );
};
